export const shadowText = {
  dropShadow: true,
  dropShadowAlpha: 0.8,
  dropShadowBlur: 4
};
export const goldFontStyle = {
  dropShadow: true,
  dropShadowAngle: 45,
  dropShadowBlur: 6,
  dropShadowColor: '#5b0200',
  fill: [
    'white',
    '#ffff6e',
    '#ffffa3',
    '#ffb209',
    '#9c4500',
    '#9c4500',
  ],
  fillGradientStops: [
    0.2,
    0.25,
    0.4,
    0.54,
    0.65,
    0.7,
    0.9
  ],
  lineJoin: 'round',
  stroke: '#ffde05',
  strokeThickness: 2,
};
export const goldFontWithoutStokesStyle = {
  breakWords: true,
  fill: [
    'white',
    '#ffff6e',
    '#ffffa3',
    '#ffb209',
    '#9c4500',
    '#9c4500',
  ],
  fillGradientStops: [
    0.2,
    0.25,
    0.4,
    0.54,
    0.65,
    0.7,
    0.9
  ],
  lineJoin: 'round',
  fontWeight: 100,
}
export const winFontStyle = {
  align: "center",
  dropShadow: true,
  dropShadowAngle: 1.5,
  dropShadowBlur: 16,
  dropShadowColor: '#4c0000',
  dropShadowDistance: 17,
  fill: [
    '#f94803',
    '#fb8b37',
    'yellow',
    '#ffff8e',
    'yellow',
    '#ff6e02'
  ],
  fillGradientStops: [
    0.22,
    0.3,
    0.4,
    0.55,
    0.72,
    0.83
  ],
  lineJoin: 'round',
  stroke: '#4a0000',
  strokeThickness: 6
}

export const mainGoldFont = {
  dropShadow: true,
  dropShadowAlpha: 0.4,
  dropShadowAngle: 1.6,
  dropShadowDistance: 4,
  fill: [
    '#feff26',
    '#ffe509',
    '#f0ff41',
    '#feffea',
    '#feff00',
    '#ff8006',
    '#fea813'
  ],
  lineJoin: 'round',
  miterLimit: 0,
  stroke: '#5b0200',
  strokeThickness: 6,
  whiteSpace: 'normal'
};

export const freespinsPopupsFont = {
  dropShadow: true,
  dropShadowAngle: 1.6,
  dropShadowColor: "#60001d",
  dropShadowDistance: 4,
  fill: [
    "#feff4e",
    "#fdff95",
    "#ffaf00",
    "#a83f00",
    "#ffa800"
  ],
  fillGradientStops: [
    0,
    0.3,
    0.6,
    0.8,
    0.9
  ],
  fontFamily: "UbuntuBold",
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#faff00",
  strokeThickness: 2,
  whiteSpace: "normal"
};

export const jackpotValues = {
  dropShadow: true,
  dropShadowAlpha: 0.4,
  dropShadowAngle: 1.6,
  dropShadowDistance: 2,
  fontWeight: "normal",
  fill: 'white',
  lineJoin: 'round',
  miterLimit: 0,
  strokeThickness: 8,
  whiteSpace: 'normal'
};

export const jackpotStrokes = {
  0: { stroke: '#054300' },
  1: { stroke: '#2a1494' },
  2: { stroke: '#6b050c' },
};
